import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const TrustConfirmation = () => {
  const { isEnglish } = useLanguage();
  
  const trustItems = isEnglish ? [
    {
      emoji: '⭐',
      text: 'Activities personally tested and validated',
      bg: 'bg-amber-50',
      border: 'border-amber-100',
    },
    {
      emoji: '📍',
      text: 'Your local contact in Hurghada',
      bg: 'bg-sky-50',
      border: 'border-sky-100',
    },
    {
      emoji: '💬',
      text: 'Easy booking and WhatsApp support',
      bg: 'bg-emerald-50',
      border: 'border-emerald-100',
    },
  ] : [
    {
      emoji: '⭐',
      text: 'Activités testées et validées personnellement',
      bg: 'bg-amber-50',
      border: 'border-amber-100',
    },
    {
      emoji: '🇫🇷 📍',
      text: 'Français basé à Hurghada',
      bg: 'bg-sky-50',
      border: 'border-sky-100',
    },
    {
      emoji: '💬',
      text: 'Réservation simple et accompagnement WhatsApp',
      bg: 'bg-emerald-50',
      border: 'border-emerald-100',
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {trustItems.map((item, index) => (
            <div
              key={index}
              className={`${item.bg} ${item.border} border rounded-2xl p-5 md:p-6 text-center transition-all duration-300 ease-out md:hover:scale-[1.03] md:hover:shadow-lg md:hover:shadow-slate-200/50 cursor-default`}
            >
              <div className="text-2xl md:text-3xl mb-3 select-none">
                {item.emoji}
              </div>
              <p className="text-slate-700 font-semibold text-sm md:text-base leading-snug">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustConfirmation;
